<template>
  <div>
    <div class="content-header">
      <div class="left"><span class="title">推送记录</span></div>
      <div class="right"></div>
    </div>
    <div class="tips" style="margin-bottom: 20px">
      <Icon type="md-alert" size="20" color="#2d8cf0" style="margin-right: 10px" />
      <div>
        <div>
          1、推送记录代表设备主动或发生异常时向服务器推送的印张计数器记录，每天只保留最新一条记录数据，如设备当日没有推送记录，可将日期向前查询；
        </div>
        <div>2、下列数据摘取设备原生计数器印张，总印张已将所有纸型换算成A4单面进行统计；</div>
      </div>
    </div>
    <div class="filter-box">
      <div class="item_box">
        <span class="subtitle">记录时间:</span>
        <DatePicker
          type="daterange"
          format="yyyy-MM-dd"
          placeholder="选择时间"
          style="width: 220px"
          @on-change="handleDateChange"
          v-model="showDate"
          class="select"
          :clearable="false"
        ></DatePicker>

        <span class="subtitle ml10">&nbsp;&nbsp;&nbsp;&nbsp;序列号:</span>
        <Input
          v-model="page.sn"
          style="width: 220px"
          placeholder="按照序列号搜索"
          clearable
        ></Input>

        <span class="subtitle ml10">设备品牌:</span>
        <Select v-model="page.brand" style="width: 220px" clearable multiple>
          <Option v-for="(item, index) in machineTypesGroup" :value="item" :key="index">{{
            item
          }}</Option>
        </Select>
      </div>
      <div class="item_box">
        <span class="subtitle" v-if="!agent.tp">合作伙伴:</span>
        <Select
          v-model="page.agent_id"
          style="width: 220px"
          v-if="!agent.tp"
          clearable
          filterable
        >
          <Option v-for="item in agentList" :value="item.id" :key="item.id">{{
            item.name
          }}</Option>
        </Select>

        <span class="subtitle ml10">所属学校:</span>
        <Select v-model="page.company_id" style="width: 220px" clearable filterable>
          <Option v-for="item in companyList" :value="item.id" :key="item.id">{{
            item.company_name
          }}</Option>
        </Select>

        <span class="subtitle ml10">所属站点:</span>
        <Select v-model="page.site_id" style="width: 220px" clearable filterable>
          <Option v-for="item in siteList" :value="item.id" :key="item.id">{{
            item.name
          }}</Option>
        </Select>
      </div>
      <div class="bottom">
        <span class="btn-filter" @click="getData(1)">筛选</span>
        <span class="btn" @click="reset">清空</span>

        <Poptip title="导出Excel" placement="right" trigger="hover">
          <span class="btn">导出报表</span>
          <div slot="content">
            <Button type="primary" style="margin-right: 5px" @click="exportData(0)"
              >导出当前页</Button
            >
            <Button type="success" @click="exportData(1)">导出所有页</Button>
          </div>
        </Poptip>
      </div>
    </div>

    <div style="position: relative">
      <Table size="small" :columns="columns" :data="data" :loading="tableLoading" />
      <div class="t-right" style="margin-top: 10px">
        <Page
          @on-change="pageChange"
          @on-page-size-change="sizeChange"
          :current="page.p + 1"
          :total="total"
          :page-size-opts="pageSizeOpts"
          :page-size="10"
          show-elevator
          show-sizer
          show-total
        />
      </div>
      <Spin fix v-if="tableLoading">
        <Icon type="ios-loading" size="18" class="spin-icon-load"></Icon>
        <div>加载中...</div>
      </Spin>
    </div>
  </div>
</template>

<script>
function getMonthStart() {
  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth(); // 注意：getMonth() 返回的月份是从0开始的，所以1月是0，2月是1，依此类推
  const firstDay = new Date(year, month, 1);
  return firstDay;
}
import { mapActions, mapGetters } from "vuex";
import excel from "@/libs/excel";
export default {
  data() {
    return {
      page: {
        l: 10,
        p: 0,
        start_time: "",
        end_time: "",
        brand: [],
        sn: "",
        agent_id: 0,
        site_id: 0,
        company_id: 0,
      },
      showDate: [],
      agentList: [],
      siteList: [],
      companyList: [],
      columns: [
        {
          width: 180,
          key: "update_time",
          title: "记录时间",
        },

        {
          width: 150,
          key: "sn",
          title: "序列号",
        },

        {
          width: 200,
          key: "site_name",
          title: "站点",
        },
        {
          width: 200,
          key: "company_name",
          title: "学校",
        },
        {
          width: 100,
          key: "brand",
          title: "机器品牌",
        },
        {
          width: 200,
          key: "agent_name",
          title: "合作伙伴",
        },
        {
          key: "happed",
          title: "总印张",
          width: 120,
          fixed:"right"
        },
        {
          key: "mono_happed",
          title: "总印张(黑) ",
          width: 120,
          fixed:"right"
        },
        {
          key: "color_happed",
          title: "总印张(彩)",
          width: 120,
          fixed:"right"
        },
        {
          key: "black_a3_happed",
          title: " A3(黑)",
          width: 120,
          fixed:"right"
        },
        {
          key: "color_a3_happed",
          title: "A3(彩)",
          width: 120,
          fixed:"right"
        },
      ],
      data: [],
      tableLoading: false,
      pageSizeOpts: [10, 50, 100, 150],
      total: 0,
      machineTypesGroup: [],
    };
  },
  async mounted() {
    this.tableLoading = true;
    this.showDate = [getMonthStart(), new Date()];
    this.page.start_time = this.$moment(this.showDate[0], "YYYY-MM-DD");
    this.page.end_time = this.$moment(this.showDate[1], "YYYY-MM-DD");

    //初始化agent
    if (!this.agent.tp) {
      const agentRes = await this.getAgentList({ l: 1000, p: 0, is_del: 0 });
      this.agentList = agentRes.data;
    } else {
      this.page.agent_id = this.agent.id;
    }

    //初始化site
    const siteParams = {
      l: 1000,
      p: 0,
      agent_id: this.agent.tp ? this.agent.id : 0,
      is_del: 0,
    };
    if (!siteParams.agent_id) {
      delete siteParams.agent_id;
    }
    const siteRes = await this.getSite(siteParams);
    this.siteList = siteRes.data;
    //初始化company
    const companyParams = {
      l: 100000,
      p: 0,
      agent_id: this.agent.tp ? this.agent.id : 0,
      is_del: 0,
    };
    if (!companyParams.agent_id) {
      delete companyParams.agent_id;
    }
    const companyRes = await this.getCompany(companyParams);
    this.companyList = companyRes.data;

    //初始化品牌
    this.GetMachineTypeGroup().then((res) => {
      this.machineTypesGroup = res.map((item) => {
        return item.brand;
      });
    });
    this.getData();
  },
  methods: {
    ...mapActions([
      "getAgentList",
      "getSite",
      "getCompany",
      "GetMeterLogDevices",
      "GetMachineTypeGroup",
    ]),
    handleDateChange(e) {
      this.page.start_time = e[0];
      this.page.end_time = e[1];
    },
    pageChange(p) {
      console.log("pageChange");
      this.page.p = p - 1;
      this.getData();
    },
    sizeChange(l) {
      console.log("sizeChange");
      this.page.l = l;
      this.getData();
    },
    getData(is_reset = 0) {
      if (is_reset) {
        this.page.p = 0;
        this.page.l = 10;
      }
      this.tableLoading = true;
      this.GetMeterLogDevices(this.page).then((res) => {
        res.data.map((item) => {
          item.update_time = this.$moment(item.update_time, "YYYY-MM-DD HH:mm:ss");
        });
        this.tableLoading = false;
        this.data = res.data;
        this.total = res.total;
      });
    },
    reset() {
      this.showDate = [getMonthStart(), new Date()];
      this.page.start_time = this.$moment(this.showDate[0], "YYYY-MM-DD");
      this.page.end_time = this.$moment(this.showDate[1], "YYYY-MM-DD");
      this.page = {
        l: 10,
        p: 0,
        start_time: "",
        end_time: "",
        brand: [],
        sn: "",
        agent_id: 0,
        site_id: 0,
        company_id: 0,
      };
      this.getData();
    },

    exportData(is_all = 0) {
      let title = ["编号"],
        key = ["id"];

      this.columns.map((item) => {
        title.push(item.title);
        key.push(item.key);
      });

      let params = {
        title: title,
        key: key,
        autoWidth: true,
        filename: "推送记录" + new Date().getTime(),
      };
      this.tableLoading = true;

      if (is_all) {
        let page = JSON.parse(JSON.stringify(this.page));
        page.l = this.total;
        page.p = 0;

        this.GetMeterLogDevices(page).then((res) => {
          res.data.map((item) => {
            item.update_time = this.$moment(item.update_time, "YYYY-MM-DD HH:mm:ss");
          });
          params.data = this.excelData(res.data);
          excel.export_array_to_excel(params);
          this.tableLoading = false;
        });
      } else {
        params.data = this.excelData(this.data);
        excel.export_array_to_excel(params);
        this.tableLoading = false;
      }
    },
    // 导出格式化数据
    excelData(data) {
      let result = JSON.parse(JSON.stringify(data));
      return result;
    },
  },
  computed: mapGetters({
    agent: "agent",
  }),
  watch: {},
};
</script>
<style lang="less">
@import "./index.less";
</style>
